export default __webpack_public_path__ + "img/e544ef7b47d0f06eb4d1528c5aa476bd.svg";